export const homeObjOne = {
	id: "about",
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: "Testimonial",
	headline: "Happy Customers",
	description:
		"Our rich portfolio of previous work showcases our commitment to excellence, community empowerment, and sustainable practices. We have collaborated with a diverse range of clients, including local governments, private developers, and First Nations organizations, to deliver top-notch contracting solutions tailored to their unique needs. Our projects span various sectors, such as infrastructure, commercial development, and environmental stewardship, reflecting our versatile expertise and dedication to creating lasting, positive impacts.",
	buttonLabel: "Get In Touch",
	imgStart: false,
	img: require("../../images/review.svg").default,
	alt: "Rocket",
	dark: true,
	primary: true,
	darkText: false,
};

export const homeObjTwo = {
	id: "discover",
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: "Company",
	headline: "Sneaky Travels Story",
	description:
		"Sneaky Travels is the UK’s fastest-growing travel agent. We’re on a mission to open the world to everyone. We’ve become the fastest-growing travel agent by offering unlimited choice, unmatched ease, and unmissable value. We believe that holidays refresh and renew us. That travel makes new connections and turns strangers into friends. We believe it shouldn’t be an expensive luxury.",

	buttonLabel: "Contact us to know more..",
	imgStart: true,
	img: require("../../images/Logo.svg").default,
	alt: "Planet",
	dark: false,
	primary: false,
	darkText: true,
};
